import { render, staticRenderFns } from "./industryType.vue?vue&type=template&id=058a0df8&scoped=true"
import script from "./industryType.vue?vue&type=script&lang=js"
export * from "./industryType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a0df8",
  null
  
)

export default component.exports